<template>
    <div class="container">
        <section class="career-youth-programs-template-page row">
            <div v-if="showFilter && filterData"  class="col-default-12 u-pt-l">
                <career-youth-programs-filter
                    @update-params="onFilterChange"
                    :filter="filterData">
                </career-youth-programs-filter>
            </div>

            <div v-if="isLoading" class="col-default-12 u-flex u-justify-center">
                <z-preloader />
            </div>

            <div v-if="items.length" class="col-default-12">
                <div class="career-youth-programs-template-page__cards">
                    <div
                        v-for="(item, index) in items"
                        :key="index"
                        class="career-youth-programs-template-page__card-wrapper"
                    >
                        <z-card
                            :contentData="{
                                title: item.name,
                                hiddenTitle: item.name
                            }"
                            :is-background-image="false"
                            :href="isLinkCards ? item.detailPageUrl : null"
                            :image="item.previewPicture.link"
                            theme="clipped-secondary"
                            class="career-youth-programs-template-page__card"
                        >
                            <template #bottom>
                                <div v-html="item.previewText"></div>
                            </template>
                        </z-card>
                    </div>

                </div>
            </div>

            <div v-else-if="!isLoading" class="col-default-12 u-collapse--all u-pt-l u-flex u-justify-center">
                <z-not-found></z-not-found>
            </div>

            <div class="col-default-12 u-flex u-justify-center">
                <z-pagination
                    @change-page="onPageChange"
                    :data="paginationData"
                    :loading="isLoading"
                />
            </div>

            <div v-if="showVacancies" class="col-default-12">
                <vacancy-section
                    theme="light"
                />
            </div>

            <!--<z-wide-section>
                <img class="career-youth-programs-template-page__image" src="/media/img/career/youth-programs/template/background.jpg" alt="background">
            </z-wide-section>-->
        </section>
    </div>
</template>

<script setup>
import { computed, onBeforeMount, ref, watch } from 'vue';
import { useStore } from 'vuex';

import VacancySection from '@/views/global/VacancySection'
import CareerYouthProgramsFilter from '../components/CareerYouthProgramsFilter.vue'

import { getProgramsList } from '@/api/programs-list';
import { useGetData } from '@/composable/useGetData'
import { useGetter } from '@/composable/useGetter'
import { useHandlers } from '../composable/useHandlers';


const props = defineProps({
    heroTitle: String,
    showFilter: {
        type: Boolean,
        default: true
    },
    showVacancies: {
        type: Boolean,
        default: true
    },
    isLinkCards: {
        type: Boolean,
        default: true
    }
})

const store = useStore()
const { app } = useGetter(['app'])
const isMore = ref(false)
const appData = app.value.components?.programs
const params = ref({
    type: appData?.type
})

const { isLoading, data, fetcher } = useGetData(getProgramsList, params, appData)

const { onPageChange, onUpdateParams, onFilterChange } = useHandlers(params, isMore, fetcher)

const filterData = computed(() => app.value?.components?.programs?.filter)

const paginationData = computed(() => {
    return ({
        currentPage: data.value.nav?.current || 0,
        totalItems: data.value.nav?.count || 0,
        totalPages: data.value.nav?.total || 0,
        pageRange: 1
    })
})

const items = ref(data.value?.items || [])

onBeforeMount(() => {
    store.dispatch('SetHeroTitle', props.heroTitle);
    store.dispatch('SetHeroBubble', '<p style="font-size: 64px; line-height: 64px;">>40%</p><p class="text-size-s">сотрудников компании - молодые люди <br>в возрасте <br>до 35 лет</p>');
    store.dispatch('SetHeroSocialList', [
        {id: 1, link: 'https://vk.com/irkutskoilcompany', icon: 'social/vk',},
        {id: 2, link: 'https://t.me/irkutskoilcompany', icon: 'social/telegram',},
        {id: 3, link: 'https://www.youtube.com/channel/UCTFeqMD5zZLKjjp7C52YOkQ/featured', icon: 'social/youtube',},
        {id: 4, link: 'https://max.ru/irkutskoilcompany', icon: 'social/max',},
    ]);
})

watch(data, () => {
    if (!(data.value.items && data.value.items.length)) {
        items.value = []
        return
    }

    items.value = isMore.value ? [...items.value, ...data.value.items] : items.value = data.value.items
})
</script>

<style lang="scss">
.career-youth-programs-template-page {
    min-height: 1000px;

    $parent: &;
    position: relative;

    .z-wide-section {
        z-index: -1 !important;

        #{$parent}__image {
            position: absolute;
            bottom: 0;
            left: 0;
            min-width: 101%;
            object-fit: cover;
        }
    }

    &__cards {
        display: grid;
        // grid-template-columns: repeat(4, 1fr);
        display: flex;
        flex-wrap: wrap;
        margin-left: -24px;
        margin-right: -24px;
        margin-top: -48px;

        // @include breakpoint(tablet) {
        //     grid-template-columns: repeat(3, 1fr);
        // }

        // @include breakpoint(v-tablet) {
        //     grid-template-columns: repeat(2, 1fr);
        // }

        // @include breakpoint(mobile) {
        //     grid-template-columns: repeat(1, 1fr);
        // }

        #{$parent}__card-wrapper {
            width: 25%;
            padding: 0 24px;
            margin-top: 48px;

            @include breakpoint(laptop) {
                width: 33.33%;
            }

            @include breakpoint(v-tablet) {
                width: 50%;
            }

            @include breakpoint(mobile) {
                width: 100%;
            }
        }

        #{$parent}__card {
            max-width: unset;
            aspect-ratio: 0;
            height: 100%;
        }
    }

    .z-not-found{
        width: 100%;
    }

    .vacancy-section {
        width: 100%;
        padding: 0;
        padding-top: 10%;
        padding-bottom: 14%;
    }
}
</style>
